module.exports = __webpack_public_path__ + "img/C05429_ED6129_94492A_834729-256px.bce76472.png";